import { FormBase } from 'core/components';

export default class FacilityOrderTemplateNewFlowPatientCreateForm extends FormBase {
    constructor(hooks) {      
        super(hooks);
    }

    setup() {
        
        return {
            fields: [
                {
                    name: 'firstName',
                    label: 'IMPORT_PATIENT.CREATE.FIRST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.FIRST_NAME_PLACEHOLDER',
                    rules: 'required|string'
                },
                {
                    name: 'lastName',
                    label: 'IMPORT_PATIENT.CREATE.LAST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.LAST_NAME_PLACEHOLDER',
                    rules: 'required|string'                    
                },
                {
                    name: 'dateOfBirth',
                    label: 'IMPORT_PATIENT.CREATE.DATE_OF_BIRTH_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.DATE_OF_BIRTH_PLACEHOLDER',   
                    rules: ['required']
                },
                {
                    name: 'ssn',
                    label: 'SSN',
                    placeholder: 'Enter SSN',
                    rules: ['string', 'max:11', 'regex:^([0-9]{3}-[0-9]{2}-[0-9]{4})$']
                },
                {
                    name: 'contactRelationship',
                    label: 'Relationship',
                    placeholder: 'Select Relationship',
                    rules: 'string'                    
                },
                {
                    name: 'contactPhone',
                    label: 'IMPORT_PATIENT.CREATE.PHONE_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.PHONE_PLACEHOLDER',
                    rules: ['string', 'max:10', 'regex:^([0-9]{10})$']
                },
                {
                    name: 'contactFirstName',
                    label: 'IMPORT_PATIENT.CREATE.FIRST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.FIRST_NAME_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'contactLastName',
                    label: 'IMPORT_PATIENT.CREATE.LAST_NAME_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.LAST_NAME_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'contactAddressLine1',
                    label: 'Address Line 1',
                    placeholder: 'Enter Address Line 1',
                    rules: 'string'
                },
                {
                    name: 'contactAddressLine2',
                    label: 'Address Line 2',
                    placeholder: 'Enter Address Line 2',
                    rules: 'string'
                },
                {
                    name: 'contactCity',
                    label: 'City',
                    placeholder: 'Enter City',
                    rules: 'string'
                },
                {
                    name: 'contactCountry',
                    label: 'Country',
                    placeholder: 'Enter Country',
                    rules: 'string'
                },
                {
                    name: 'contactState',
                    label: 'IMPORT_PATIENT.CREATE.STATE_LABEL',
                    placeholder: 'IMPORT_PATIENT.CREATE.STATE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'contactPostalCode',
                    label: 'Postal Code',
                    placeholder: 'Enter Postal Code',
                    rules: ['numeric', 'max:999999999']
                },
                {
                    name: 'gender',
                    label: 'IMPORT_PATIENT.CREATE.GENDER_LABEL',
                    placeholder: 'Select Gender',      
                    rules: 'required'           
                },
                {
                    name: 'height',
                    label: 'Height',
                    placeholder: 'Enter Height',
                    rules: ['numeric', 'max:99.99']    

                },
                {
                    name: 'weight',
                    label: 'Weight',
                    placeholder: 'Enter Weight',
                    rules: ['numeric', 'max:999.99']                     
                },
                {
                    name: 'doc',
                    label: 'Ordering Doctor',
                    placeholder: 'Select Ordering Doctor',
                },
                {
                    name: 'orderingDoctorId',
                    label: 'Ordering Doctor Id',
                },
                {
                    name: 'subCategoryId',
                    label: 'Sub Category',
                    placeholder: 'Select Sub Category',
                    rules: 'required' 
                },
                {
                    name: "portalNote",
                    label: "FACILITY_ORDER_TEMPLATE.EDIT.NOTE_LABEL",
                    placeholder: "FACILITY_ORDER_TEMPLATE.EDIT.NOTE_PLACEHOLDER",
                    rules: "string"
                },
                {
                    name: 'eligibilityStatusId',
                    label: 'Eligibility Status',
                    placeholder: 'Select Eligibility Status',
                    rules: 'required'
                },
            ],
        };
    }
}
